/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container: ' + container);
//       console.log('Variant: ' + variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart: ' + cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });

  // Debounced scroll listeners.  Up and down only fire on directions changes
  // These events are useful for creating sticky headers and footers.
  var body = document.body;
  var html = document.getElementsByTagName( 'html' )[0];
  var header = document.getElementsByTagName( 'header' )[0];
  
 var ats_styles = `html,body{  background: linear-gradient(-45deg, rgb(253,236,207), rgb(255,255,255)) 0% 0% / 400% 100%};`
  var styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = ats_styles;


  document.addEventListener('theme:scroll', e => { 
    
    if(e.detail.position < 50){
      header.classList.remove("ats_theme_header_show");
      header.classList.remove("ats_theme_header_hide");
    	
    }
    
    if(e.detail.position > 150){
      //console.log("arko");
      html.classList.add("ats_scroll_active");
      body.classList.add("ats_scroll_active");
      document.head.appendChild(styleSheet);
    	
    }else{
      html.classList.remove("ats_scroll_active");
      body.classList.remove("ats_scroll_active");
      
    }
    //console.log(e); 
  });
   document.addEventListener('theme:scroll:up', e => { 
     console.log(header);
     header.classList.add("ats_theme_header_show");
     header.classList.remove("ats_theme_header_hide");
     //console.log(e); 
   });
   document.addEventListener('theme:scroll:down', e => { 
     header.classList.add("ats_theme_header_hide");
     header.classList.remove("ats_theme_header_show");
     //console.log(e); 
   });

  // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


